export const common = {
  // Navigation
  nav_features: 'Features',
  nav_security: 'Security',
  nav_community: 'Community',
  nav_join: 'Join Now',
  nav_back_home: 'Back to Home',
  nav_new_project: 'NEW PROJECT',
  
  // New Projects Modal
  new_projects_title: 'New Projects',
  new_projects_subtitle: 'Explore our latest features and updates',
  new_projects_close: 'Close',
  
  project1_title: 'AI Video Verification',
  project1_desc: 'Advanced AI technology to verify video content authenticity',
  project1_status: 'Coming Soon',
  
  project2_title: 'Global Marketplace',
  project2_desc: 'Buy and sell verified products from trusted sellers worldwide',
  project2_status: 'In Development',
  
  project3_title: 'Live Events',
  project3_desc: 'Join live streaming events with verified participants',
  project3_status: 'Beta Testing',
  
  project4_title: 'Education Hub',
  project4_desc: 'Learn new skills with verified instructors and courses',
  project4_status: 'Coming Soon',
  
  project5_title: 'Business Network',
  project5_desc: 'Connect with verified business professionals globally',
  project5_status: 'In Development',
  
  project6_title: 'Health & Wellness',
  project6_desc: 'Access verified health information and wellness programs',
  project6_status: 'Planning',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: 'Identity-Verified Social Network',
  hero_description_1: 'No fake accounts. No bullying. No violence.',
  hero_description_2: 'No toxicity. No extremism.',
  hero_description_3: '100% positive - AI verified.',
  hero_explore_btn: 'Explore Now',
  hero_signup_btn: 'Sign Up Free',
  
  // How It Works
  how_title: 'How It Works',
  step1_title: 'Face Verification',
  step1_desc: 'Take a selfie → AI verifies identity → Instant verification',
  step1_badge: 'No fake accounts',
  step2_title: 'Clean Content',
  step2_desc: 'AI filters toxic, fraudulent, violent content 24/7',
  step2_badge: 'AI Filter 24/7',
  step3_title: 'Global Community',
  step3_desc: 'Post nationally or globally',
  step3_badge: 'World Countries',
  
  // Age-Based Content
  age_title: 'Age-Appropriate Content',
  children_label: 'CHILDREN',
  children_title: 'For Children',
  children_feature1: 'Safe educational content',
  children_feature2: 'Friendly environment',
  children_feature3: 'Parental supervision',
  adults_label: 'ADULTS',
  adults_title: 'For Adults',
  adults_feature1: 'Social discussions',
  adults_feature2: 'Career & lifestyle',
  adults_feature3: 'Global connections',
  seniors_label: 'SENIORS',
  seniors_title: 'For Seniors',
  seniors_feature1: 'Health information',
  seniors_feature2: 'Share experiences',
  seniors_feature3: 'Support community',
  
  // Why Different
  why_title: 'Why Choose FaceTrue',
  why_feature1_title: '100% real people',
  why_feature1_desc: 'AI identity verification, eliminate fake accounts',
  why_feature2_title: 'No violence & toxicity',
  why_feature2_desc: 'AI filters violent, toxic, bullying content 24/7',
  why_feature3_title: 'No extremism',
  why_feature3_desc: 'Eliminate all forms of extremism and hatred',
  why_feature4_title: '100% positive',
  why_feature4_desc: 'Only positive, constructive and healthy content',
  why_feature5_title: 'Safe for all ages',
  why_feature5_desc: 'Smart content classification, suitable for each age',
  why_feature6_title: '3-flag warning system',
  why_feature6_desc: 'Yellow Flag (1st offense) → Red Flag (2nd offense) → Black Flag (3rd offense - account locked)',
  why_feature7_title: 'Star rating system',
  why_feature7_desc: 'Share positive info, images, videos → Receive pink heart stars from community',
  why_feature8_title: 'Authentic advertising',
  why_feature8_desc: 'AI checks ad authenticity. Products verified for origin before posting',
  
  // Video Demo
  video_title: 'FaceTrue Demo Video',
  video_subtitle: 'See how it works',
  video_views: 'views',
  video_close: 'Click X to close',
  video_demo_live: 'DEMO LIVE',
  video_info: 'Simulated FaceTrue demo',
  video_info_cta: 'Click Play to watch demo',
  video_update: 'Real video will be updated from Veo AI',
  
  // Video Stages
  scanning_title: 'Verifying...',
  scanning_desc: 'AI is checking identity',
  scanning_step1: 'Face detected',
  scanning_step2: 'AI verification',
  scanning_step3: 'Creating profile...',
  scanning_badge: '100% Real People',
  
  intro_step1_title: 'Verification successful',
  intro_step1_subtitle: '100% real people',
  intro_step2_title: 'AI content filtering',
  intro_step2_subtitle: 'No toxicity, no violence',
  intro_step3_title: 'Global connection',
  intro_step3_subtitle: '119 countries',
  intro_step4_title: '100% positive',
  intro_step4_subtitle: 'Only healthy content',
  intro_step5_title: 'Safe for all ages',
  intro_step5_subtitle: 'Children • Adults • Seniors',
  
  stats_title: 'FaceTrue Community',
  stats_subtitle: 'Growing strong',
  stats_users: 'Users',
  stats_countries: 'Countries',
  stats_posts: 'Positive posts',
  stats_badge: '100% Positive',
  
  comparison_title: 'The Difference',
  comparison_old: 'Old social media',
  comparison_old_1: 'Fake accounts',
  comparison_old_2: 'Toxic content',
  comparison_old_3: 'Violence',
  comparison_old_4: 'Fraud',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100% real people',
  comparison_new_2: 'Clean content',
  comparison_new_3: '100% positive',
  comparison_new_4: 'AI safe',
  
  // CTA Section
  cta_title: 'Join Now',
  cta_subtitle: 'Sign up for FaceTrue Beta',
  cta_name: 'Full name',
  cta_email: 'Your email',
  cta_button: 'Sign up now',
  cta_submitting: 'Submitting...',
  cta_success: '🎉 Thank you! We will contact you soon.',
  cta_error: '❌ An error occurred. Please try again.',
  cta_privacy: 'We respect your privacy',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue Global Social Network',
  footer_creator: 'Created by Ben Nguyen',
  footer_powered: 'Website Builder',
  
  // Time
  time_hours_ago: 'hours ago',
  time_day_ago: 'day ago',
  
  // Children Page
  children_nav_features: 'Features',
  children_nav_safety: 'Safety',
  children_nav_activities: 'Activities',
  children_back_home: 'Back to Home',
  
  children_hero_title: 'Welcome to',
  children_hero_subtitle: 'little angels',
  children_hero_desc: 'A safe, fun, and educational space designed just for kids!<br />100% parent-approved content with AI protection.',
  children_explore_btn: 'Explore Features',
  children_safety_btn: 'Safety First',
  
  children_features_title: 'Fun & Educational Features',
  children_features_subtitle: 'Everything kids need to learn, play, and grow safely',
  
  children_feature1_title: 'Educational Content',
  children_feature1_desc: 'Age-appropriate learning materials, fun quizzes, and interactive lessons that make education exciting.',
  
  children_feature2_title: 'Safe Games',
  children_feature2_desc: 'Carefully curated games that are fun, educational, and completely safe for children to enjoy.',
  
  children_feature3_title: 'Creative Activities',
  children_feature3_desc: 'Drawing, coloring, storytelling, and other creative activities to spark imagination.',
  
  children_safety_title: 'Your Child\'s Safety is Our Priority',
  children_safety_subtitle: 'Multiple layers of protection to ensure a worry-free experience',
  
  children_safety1_title: 'AI Content Filtering',
  children_safety1_desc: '24/7 AI monitoring ensures only appropriate content reaches children.',
  
  children_safety2_title: 'Parental Controls',
  children_safety2_desc: 'Parents can monitor activity and set time limits for healthy usage.',
  
  children_safety3_title: 'No Strangers',
  children_safety3_desc: 'Children can only interact with verified friends and family members.',
  
  children_activities_title: 'Explore Fun Activities',
  children_activities_subtitle: 'Click on any activity to learn more and start playing!',
  
  // 8 Activities
  activity1_title: 'Drawing & Art',
  activity1_desc: 'Create amazing artwork with digital tools',
  
  activity2_title: 'Educational Games',
  activity2_desc: 'Learn while having fun with interactive games',
  
  activity3_title: 'Stories & Reading',
  activity3_desc: 'Explore magical worlds through stories',
  
  activity4_title: 'Music & Songs',
  activity4_desc: 'Discover fun songs and melodies',
  
  activity5_title: 'Photo & Video',
  activity5_desc: 'Capture and share special moments',
  
  activity6_title: 'Group Activities',
  activity6_desc: 'Play and learn together with friends',
  
  activity7_title: 'Challenges & Rewards',
  activity7_desc: 'Complete fun challenges and earn rewards',
  
  activity8_title: 'Special Events',
  activity8_desc: 'Join exciting seasonal activities',
  
  // Drawing Activity
  children_activity_drawing: 'Drawing & Art',
  children_activity_drawing_desc: 'Create amazing artwork',
  children_activity_drawing_full: 'Unleash your creativity with our digital drawing tools! Create colorful masterpieces, learn basic art techniques, and share your artwork with friends.',
  children_activity_drawing_participants: '45,000+ kids enjoying',
  children_activity_drawing_feature1: 'Digital Drawing Tools',
  children_activity_drawing_feature2: 'Coloring Pages',
  children_activity_drawing_feature3: 'Art Tutorials',
  children_activity_drawing_feature4: 'Share Your Art',
  children_activity_drawing_feature5: 'Weekly Challenges',
  
  // Music Activity
  children_activity_music: 'Music & Songs',
  children_activity_music_desc: 'Listen to fun songs',
  children_activity_music_full: 'Discover fun songs, learn musical instruments, and create your own melodies! Enjoy educational songs that make learning exciting.',
  children_activity_music_participants: '38,000+ kids enjoying',
  children_activity_music_feature1: 'Fun Songs Library',
  children_activity_music_feature2: 'Music Games',
  children_activity_music_feature3: 'Instrument Learning',
  children_activity_music_feature4: 'Sing Along',
  children_activity_music_feature5: 'Create Melodies',
  
  // Stories Activity
  children_activity_stories: 'Stories & Reading',
  children_activity_stories_desc: 'Read exciting tales',
  children_activity_stories_full: 'Dive into magical worlds with interactive stories! Read exciting tales, listen to audiobooks, and even create your own stories.',
  children_activity_stories_participants: '52,000+ kids enjoying',
  children_activity_stories_feature1: 'Interactive Stories',
  children_activity_stories_feature2: 'Audiobooks',
  children_activity_stories_feature3: 'Reading Games',
  children_activity_stories_feature4: 'Story Creator',
  children_activity_stories_feature5: 'Book Club',
  
  // Puzzles Activity
  children_activity_puzzles: 'Puzzles & Games',
  children_activity_puzzles_desc: 'Solve fun challenges',
  children_activity_puzzles_full: 'Challenge your brain with fun puzzles and educational games! Solve mysteries, complete challenges, and learn while playing.',
  children_activity_puzzles_participants: '61,000+ kids enjoying',
  children_activity_puzzles_feature1: 'Brain Teasers',
  children_activity_puzzles_feature2: 'Logic Puzzles',
  children_activity_puzzles_feature3: 'Math Games',
  children_activity_puzzles_feature4: 'Word Games',
  children_activity_puzzles_feature5: 'Memory Challenges',
  
  // Science Activity
  children_activity_science: 'Science & Discovery',
  children_activity_science_desc: 'Explore and experiment',
  children_activity_science_full: 'Explore the wonders of science! Conduct virtual experiments, learn about nature, space, and discover how things work.',
  children_activity_science_participants: '29,000+ kids enjoying',
  children_activity_science_feature1: 'Virtual Experiments',
  children_activity_science_feature2: 'Nature Exploration',
  children_activity_science_feature3: 'Space Adventures',
  children_activity_science_feature4: 'How Things Work',
  children_activity_science_feature5: 'Science Quiz',
  
  // Sports Activity
  children_activity_sports: 'Sports & Fitness',
  children_activity_sports_desc: 'Stay active and healthy',
  children_activity_sports_full: 'Stay active and healthy! Learn about different sports, follow fun exercise routines, and track your fitness journey.',
  children_activity_sports_participants: '34,000+ kids enjoying',
  children_activity_sports_feature1: 'Exercise Videos',
  children_activity_sports_feature2: 'Sports Learning',
  children_activity_sports_feature3: 'Fitness Challenges',
  children_activity_sports_feature4: 'Healthy Habits',
  children_activity_sports_feature5: 'Activity Tracker',
  
  // Coding Activity
  children_activity_coding: 'Coding & Tech',
  children_activity_coding_desc: 'Learn to code',
  children_activity_coding_full: 'Learn to code through fun games and projects! Build simple programs, create animations, and discover the world of technology.',
  children_activity_coding_participants: '27,000+ kids enjoying',
  children_activity_coding_feature1: 'Block Coding',
  children_activity_coding_feature2: 'Simple Projects',
  children_activity_coding_feature3: 'Coding Games',
  children_activity_coding_feature4: 'Animation Creator',
  children_activity_coding_feature5: 'Tech Basics',
  
  // Nature Activity
  children_activity_nature: 'Nature & Animals',
  children_activity_nature_desc: 'Discover wildlife',
  children_activity_nature_full: 'Discover amazing animals and beautiful nature! Learn about wildlife, plants, and how to protect our planet.',
  children_activity_nature_participants: '41,000+ kids enjoying',
  children_activity_nature_feature1: 'Animal Facts',
  children_activity_nature_feature2: 'Nature Videos',
  children_activity_nature_feature3: 'Plant Learning',
  children_activity_nature_feature4: 'Eco Activities',
  children_activity_nature_feature5: 'Wildlife Quiz',
  
  // Children Safety Section
  children_safety_title: 'Your Child\'s Safety is Our Priority',
  children_safety_subtitle: 'Multiple layers of protection to ensure a worry-free experience',
  
  children_safety1_title: 'AI Content Filtering',
  children_safety1_desc: '24/7 AI monitoring ensures only appropriate content reaches children.',
  
  children_safety2_title: 'Parental Controls',
  children_safety2_desc: 'Parents can monitor activity and set time limits for healthy usage.',
  
  children_safety3_title: 'No Strangers',
  children_safety3_desc: 'Children can only interact with verified friends and family members.',
  
  children_safety4_title: 'Privacy Protected',
  children_safety4_desc: 'Personal information is encrypted and never shared with third parties.',
  
  // Children Footer
  children_footer_copyright: '© 2025 FaceTrue Children\'s Zone',
  children_footer_desc: 'A safe space for kids to learn and play',
  
  // Children Modal
  children_modal_safe_badge: 'Safe & Fun',
  children_modal_what_you_can_do: 'What You Can Do',
  children_modal_start_btn: 'Start Activity',
  
  // Adults Page
  adults_nav_features: 'Features',
  adults_nav_community: 'Community',
  adults_nav_benefits: 'Benefits',
  adults_back_home: 'Back to Home',
  
  adults_hero_title: 'Connect with',
  adults_hero_subtitle: 'Real People, Real Stories',
  adults_hero_desc: 'Join a verified community of adults sharing authentic experiences,<br />building meaningful connections, and growing together.',
  adults_explore_btn: 'Explore Features',
  adults_join_btn: 'Join Community',
  
  adults_features_title: 'Everything You Need to Connect',
  adults_features_subtitle: 'Professional networking, lifestyle sharing, and meaningful conversations',
  
  adults_feature1_title: 'Career & Professional',
  adults_feature1_desc: 'Network with professionals, share career insights, and discover opportunities in your field.',
  
  adults_feature2_title: 'Lifestyle & Interests',
  adults_feature2_desc: 'Share your passions, hobbies, and daily life with like-minded individuals worldwide.',
  
  adults_feature3_title: 'Deep Conversations',
  adults_feature3_desc: 'Engage in meaningful discussions about topics that matter to you with verified users.',
  
  adults_community_title: 'Join Global Communities',
  adults_community_subtitle: 'Connect with people who share your interests and values',
  
  adults_community_entrepreneurs: 'Entrepreneurs',
  adults_community_entrepreneurs_desc: 'Business ideas & startup discussions',
  adults_community_entrepreneurs_full: 'Connect with innovative minds and business leaders from around the world. Share startup ideas, discuss business strategies, and find potential co-founders.',
  adults_community_entrepreneurs_members: '125,000+ members',
  adults_community_entrepreneurs_topic1: 'Startup Ideas',
  adults_community_entrepreneurs_topic2: 'Funding & Investment',
  adults_community_entrepreneurs_topic3: 'Business Strategy',
  adults_community_entrepreneurs_topic4: 'Marketing & Growth',
  adults_community_entrepreneurs_topic5: 'Product Development',
  
  adults_community_health: 'Health & Wellness',
  adults_community_health_desc: 'Fitness, nutrition & mental health',
  adults_community_health_full: 'Join a supportive community focused on physical and mental well-being. Share fitness routines, nutrition tips, and mental health resources.',
  adults_community_health_members: '230,000+ members',
  adults_community_health_topic1: 'Fitness & Exercise',
  adults_community_health_topic2: 'Nutrition & Diet',
  adults_community_health_topic3: 'Mental Health',
  adults_community_health_topic4: 'Yoga & Meditation',
  adults_community_health_topic5: 'Healthy Lifestyle',
  
  adults_community_arts: 'Arts & Culture',
  adults_community_arts_desc: 'Creative expression & cultural exchange',
  adults_community_arts_full: 'Celebrate creativity and cultural diversity. Share your artwork, discover new artists, and engage in meaningful cultural discussions.',
  adults_community_arts_members: '180,000+ members',
  adults_community_arts_topic1: 'Visual Arts',
  adults_community_arts_topic2: 'Music & Performance',
  adults_community_arts_topic3: 'Literature',
  adults_community_arts_topic4: 'Film & Photography',
  adults_community_arts_topic5: 'Cultural Exchange',
  
  adults_community_travel: 'Travel & Adventure',
  adults_community_travel_desc: 'Share experiences & travel tips',
  adults_community_travel_full: 'Explore the world with fellow travelers. Share travel experiences, get destination recommendations, and find travel companions.',
  adults_community_travel_members: '310,000+ members',
  adults_community_travel_topic1: 'Travel Tips',
  adults_community_travel_topic2: 'Destination Guides',
  adults_community_travel_topic3: 'Budget Travel',
  adults_community_travel_topic4: 'Adventure Sports',
  adults_community_travel_topic5: 'Cultural Experiences',
  
  adults_community_food: 'Food & Cooking',
  adults_community_food_desc: 'Recipes, restaurants & culinary arts',
  adults_community_food_full: 'A delicious community for food lovers and home chefs. Share recipes, restaurant reviews, and culinary adventures.',
  adults_community_food_members: '275,000+ members',
  adults_community_food_topic1: 'Recipes & Cooking',
  adults_community_food_topic2: 'Restaurant Reviews',
  adults_community_food_topic3: 'Baking & Desserts',
  adults_community_food_topic4: 'International Cuisine',
  adults_community_food_topic5: 'Food Photography',
  
  adults_community_technology: 'Technology',
  adults_community_technology_desc: 'Tech trends & innovation',
  adults_community_technology_full: 'Stay ahead of tech trends and innovations. Discuss latest gadgets, programming, AI, and the future of technology.',
  adults_community_technology_members: '195,000+ members',
  adults_community_technology_topic1: 'Programming & Dev',
  adults_community_technology_topic2: 'AI & Machine Learning',
  adults_community_technology_topic3: 'Gadgets & Reviews',
  adults_community_technology_topic4: 'Cybersecurity',
  adults_community_technology_topic5: 'Tech News',
  
  adults_community_parenting: 'Parenting',
  adults_community_parenting_desc: 'Family life & parenting tips',
  adults_community_parenting_full: 'Support and advice for parents at every stage. Share parenting tips, challenges, and celebrate milestones together.',
  adults_community_parenting_members: '340,000+ members',
  adults_community_parenting_topic1: 'Parenting Tips',
  adults_community_parenting_topic2: 'Child Development',
  adults_community_parenting_topic3: 'Education',
  adults_community_parenting_topic4: 'Family Activities',
  adults_community_parenting_topic5: 'Work-Life Balance',
  
  adults_community_education: 'Education',
  adults_community_education_desc: 'Learning & personal development',
  adults_community_education_full: 'Lifelong learners unite! Share educational resources, discuss learning strategies, and grow together.',
  adults_community_education_members: '210,000+ members',
  adults_community_education_topic1: 'Online Learning',
  adults_community_education_topic2: 'Career Development',
  adults_community_education_topic3: 'Language Learning',
  adults_community_education_topic4: 'Academic Discussion',
  adults_community_education_topic5: 'Study Tips',
  
  adults_community_active: 'Active Community',
  adults_community_join_btn: 'Join Community',
  adults_community_popular_topics: 'Popular Topics',
  
  adults_benefits_title: 'Why Adults Choose FaceTrue',
  adults_benefits_subtitle: 'A social network built for authentic adult connections',
  
  adults_benefit1_title: 'Verified Identities',
  adults_benefit1_desc: 'Connect with confidence knowing everyone is who they say they are.',
  
  adults_benefit2_title: 'No Toxicity',
  adults_benefit2_desc: 'AI filtering removes harassment, hate speech, and negative content.',
  
  adults_benefit3_title: 'Global Reach',
  adults_benefit3_desc: 'Connect with verified users across 119 countries worldwide.',
  
  adults_benefit4_title: 'Privacy First',
  adults_benefit4_desc: 'Your data is protected with enterprise-grade security measures.',
  
  adults_footer_copyright: '© 2025 FaceTrue Adults Community',
  adults_footer_desc: 'Connect authentically with verified adults worldwide',
  
  // Seniors Page
  seniors_nav_features: 'Features',
  seniors_nav_health: 'Health',
  seniors_nav_community: 'Community',
  seniors_back_home: 'Back to Home',
  
  seniors_hero_title: 'A Community',
  seniors_hero_subtitle: 'Built for Seniors',
  seniors_hero_desc: 'Share your wisdom, stay connected with loved ones,<br />and enjoy a safe, supportive online community.',
  seniors_explore_btn: 'Explore Features',
  seniors_safety_btn: 'Join Community',
  
  seniors_features_title: 'What You Can Do on FaceTrue',
  seniors_features_subtitle: 'Connect, share, and enjoy meaningful interactions',
  
  seniors_feature1_title: 'Family Connections',
  seniors_feature1_desc: 'Stay connected with family members across the globe. Share photos, videos, and life updates in a safe environment.',
  
  seniors_feature2_title: 'Share Your Story',
  seniors_feature2_desc: 'Share your life experiences, wisdom, and memories with others. Your stories matter and inspire.',
  
  seniors_feature3_title: 'Make New Friends',
  seniors_feature3_desc: 'Connect with people who share your interests and hobbies. Build meaningful friendships.',
  
  seniors_feature4_title: 'Local Events',
  seniors_feature4_desc: 'Discover and join local community events, activities, and gatherings near you.',
  
  seniors_feature5_title: 'Learn New Skills',
  seniors_feature5_desc: 'Access tutorials, tips, and guidance on technology, hobbies, and daily life skills.',
  
  seniors_feature6_title: 'Support Groups',
  seniors_feature6_desc: 'Join support communities for health, wellness, and life challenges. You\'re not alone.',
  
  seniors_health_title: 'Health & Wellness Resources',
  seniors_health_subtitle: 'Stay informed and healthy with trusted information',
  
  seniors_health1_title: 'Health Tips',
  seniors_health1_desc: 'Daily health advice, nutrition tips, and exercise guidance tailored for seniors.',
  
  seniors_health2_title: 'Mental Wellness',
  seniors_health2_desc: 'Support for mental health, mindfulness practices, and stress management.',
  
  seniors_health3_title: 'Medication Reminders',
  seniors_health3_desc: 'Set reminders for medications and health appointments to stay on track.',
  
  seniors_health4_title: 'Activity Tracking',
  seniors_health4_desc: 'Track your daily activities, steps, and celebrate your wellness milestones.',
  
  seniors_community_title: 'Connect with Your Community',
  seniors_community_subtitle: 'Find support, share experiences, and make meaningful connections',
  
  seniors_community_family: 'Family Connections',
  seniors_community_family_desc: 'Stay close with family members',
  seniors_community_family_full: 'Connect with your family members across generations. Share photos, videos, and memories with your children and grandchildren. Stay updated on family events and milestones.',
  seniors_community_family_members: '2.8M members',
  seniors_community_family_topic1: 'Family Updates',
  seniors_community_family_topic2: 'Photo Sharing',
  seniors_community_family_topic3: 'Video Calls',
  seniors_community_family_topic4: 'Family Events',
  seniors_community_family_topic5: 'Grandchildren Stories',
  
  seniors_community_stories: 'Share Your Story',
  seniors_community_stories_desc: 'Life experiences & wisdom',
  seniors_community_stories_full: 'Share your life experiences, wisdom, and stories with younger generations. Your memories and lessons learned are valuable treasures that can inspire and guide others.',
  seniors_community_stories_members: '1.9M members',
  seniors_community_stories_topic1: 'Life Stories',
  seniors_community_stories_topic2: 'Historical Events',
  seniors_community_stories_topic3: 'Career Experiences',
  seniors_community_stories_topic4: 'Life Lessons',
  seniors_community_stories_topic5: 'Family History',
  
  seniors_community_friends: 'Make New Friends',
  seniors_community_friends_desc: 'Connect with peers worldwide',
  seniors_community_friends_full: 'Meet and connect with other seniors who share your interests, hobbies, and life experiences. Build meaningful friendships and enjoy social connections.',
  seniors_community_friends_members: '3.2M members',
  seniors_community_friends_topic1: 'Friendship',
  seniors_community_friends_topic2: 'Social Activities',
  seniors_community_friends_topic3: 'Common Interests',
  seniors_community_friends_topic4: 'Group Chats',
  seniors_community_friends_topic5: 'Meetups',
  
  seniors_community_events: 'Local Events',
  seniors_community_events_desc: 'Community activities & gatherings',
  seniors_community_events_full: 'Discover local events, activities, and gatherings designed for seniors in your area. Stay active and engaged with your local community.',
  seniors_community_events_members: '1.5M members',
  seniors_community_events_topic1: 'Community Events',
  seniors_community_events_topic2: 'Senior Centers',
  seniors_community_events_topic3: 'Social Gatherings',
  seniors_community_events_topic4: 'Local Activities',
  seniors_community_events_topic5: 'Workshops',
  
  seniors_community_learning: 'Learn New Skills',
  seniors_community_learning_desc: 'Never stop growing & learning',
  seniors_community_learning_full: 'Never stop learning! Access easy-to-follow tutorials, online classes, and educational content designed specifically for seniors. Learn at your own pace.',
  seniors_community_learning_members: '2.1M members',
  seniors_community_learning_topic1: 'Technology Basics',
  seniors_community_learning_topic2: 'Arts & Crafts',
  seniors_community_learning_topic3: 'Cooking Classes',
  seniors_community_learning_topic4: 'Language Learning',
  seniors_community_learning_topic5: 'Hobbies',
  
  seniors_community_support: 'Support Groups',
  seniors_community_support_desc: 'Find understanding & encouragement',
  seniors_community_support_full: 'Find support and understanding from others who share similar health conditions or life situations. Share experiences and get emotional support.',
  seniors_community_support_members: '1.7M members',
  seniors_community_support_topic1: 'Health Support',
  seniors_community_support_topic2: 'Grief Support',
  seniors_community_support_topic3: 'Caregiver Support',
  seniors_community_support_topic4: 'Chronic Conditions',
  seniors_community_support_topic5: 'Mental Health',
  
  seniors_community_popular_topics: 'Popular Topics:',
  seniors_community_join_btn: 'Join Community',
  
  seniors_benefits_title: 'Why Seniors Love FaceTrue',
  seniors_benefits_subtitle: 'A social network that respects and values your experience',
  
  seniors_benefit1_title: 'No Scams or Fraud',
  seniors_benefit1_desc: 'AI protection against scammers and fraudulent activities.',
  
  seniors_benefit2_title: 'Large, Clear Text',
  seniors_benefit2_desc: 'Easy-to-read interface designed for comfortable viewing.',
  
  seniors_benefit3_title: '24/7 Support',
  seniors_benefit3_desc: 'Help is always available when you need assistance.',
  
  seniors_benefit4_title: 'Privacy Protected',
  seniors_benefit4_desc: 'Your personal information is always kept secure and private.',
  
  seniors_benefit5_title: 'Respectful Community',
  seniors_benefit5_desc: 'A positive environment where everyone treats each other with respect.',
  
  seniors_benefit6_title: 'Free to Use',
  seniors_benefit6_desc: 'All features available at no cost to you.',
  
  seniors_footer_copyright: '© 2025 FaceTrue Seniors Community',
  seniors_footer_desc: 'A safe and supportive space for seniors to connect',
};

export default common;
